module.exports = __webpack_public_path__ + "static/media/V6.49739d82.mp4";